import { Box, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ScrollTable from 'components/global/CUK/ScrollTable'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'
import EmptyScreen from 'packages/ui/EmptyScreen'
import TableView, { IItem, useTable } from 'packages/ui/Table'
import { useUser } from 'store'

import { Ssid } from '../types'
import COLUMNS_CONFIG from './config-columns'
import { canEdit } from '../MonitoringSsids'

interface SsidsTableProps {
  loading: boolean
  ssids: Ssid[]
  onEdit: (ssid: Ssid) => void
}

const SsidsTable = ({ loading, ssids, onEdit }: SsidsTableProps) => {
  const { t } = useTranslation()
  const [user] = useUser()
  const apiTable = useTable({
    rowKey: 'name',
    loading: false,
    items: ssids as unknown as IItem[],
    columns: COLUMNS_CONFIG,
    onSendAction: (action, item) => {
      if (canEdit(user) && action === 'edit') {
        onEdit(item as unknown as Ssid)
      }
    }
  })

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden'
      }}>
      {loading ? (
        <TableSkeleton />
      ) : ssids.length === 0 ? (
        <Stack alignItems="center" flex={1} justifyContent="center" sx={{ minHeight: 220 }}>
          <EmptyScreen icon="wifi" iconSize="64px">
            {t('ssid_monitoring.empty')}
          </EmptyScreen>
        </Stack>
      ) : (
        <ScrollTable shouldFetchNextPage={false} style={{ height: '100%', overflow: 'auto' }}>
          <TableView apiTable={apiTable} />
        </ScrollTable>
      )}
    </Box>
  )
}

export default SsidsTable
